<template>
  <div class="h-100">
    <b-row class="h-100">
      <b-col md="10" class="settings-panel">
        <div class="card">
          <div class="card-header text-center">
            Connection Method
          </div>
          <b-row class="settings-card-body">
            <b-col class="settings-panel-body connectionmethod">
              <div class="card-block">
                <b-form v-if="form">
                  <b-form-group class="mode-group py-4">
                    <label>Choose Connection Method</label>
                    <b-form-radio-group button-variant="outline-custom" buttons v-model="form.connectionMethod" :options="options" class="active" @input="setDefaults()"></b-form-radio-group>
                  </b-form-group>
                  <b-form-group label="Choose Mode" v-if="form.connectionMethod=='manual'">
                    <b-form-radio-group id="radios1" v-model="connectionMode" name="mode" @input="setRunnerDefaults">
                      <b-form-radio :value="mode.value" v-for="(mode,index) in modeOptions" :key="index" :disabled="checkModeDisabled(mode.value)">
                        <span :id="mode.value">{{mode.text}}</span>
                        <b-tooltip ref="tooltip" :target="mode.value" :disabled="!checkModeDisabled(mode.value)">
                          This Method is not compatible
                        </b-tooltip>
                      </b-form-radio>

                    </b-form-radio-group>
                  </b-form-group>
                  <b-form-group label="Choose Runner" v-if="form.connectionMethod=='manual' && connectionMode!='curlMode'">
                    <b-form-radio-group v-if="connectionMode=='commandMode'" id="radios2" v-model="connectionRunner" name="runner">
                      <b-form-radio :value="runner.value" v-for="(runner,index) in runnerOptions['commandMode']" :key="index" :disabled="checkRunnerDisabled(runner.value)">
                        <span :id="runner.value">{{runner.text}}</span>
                        <b-tooltip ref="tooltip" :target="runner.value" :disabled="!checkRunnerDisabled(runner.value)">
                          This Method is not compatible
                        </b-tooltip>
                      </b-form-radio>

                    </b-form-radio-group>
                    <b-form-radio-group v-if="connectionMode=='socketMode'" id="radios2" v-model="connectionRunner" name="runner">
                      <b-form-radio :value="runner.value" v-for="(runner,index) in runnerOptions['socketMode']" :key="index" :disabled="checkRunnerDisabled(runner.value)">
                        <span :id="runner.value">{{runner.text}}</span>
                        <b-tooltip ref="tooltip" :target="runner.value" :disabled="!checkRunnerDisabled(runner.value)">
                          This Method is not compatible
                        </b-tooltip>
                      </b-form-radio>

                    </b-form-radio-group>
                  </b-form-group>
                </b-form>
              </div>
            </b-col>
          </b-row>
          <div class="card-footer text-muted text-right">
            <a class="helper-links" v-if="isEveryModesDisabled()" target="_blank" :href="appInfo.SUPPORT_URL+'solution/articles/226079-connection-methods'+appInfo.GA_HELP_TRACKING">Why are some of my options disabled?</a>
            <b-btn variant="primary" size="sm" @click="save">Save Changes
              <spinner size="small" v-if="buttonLoaders.saveChanges"></spinner>
            </b-btn>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'connectionmethodsetting',
  props: ['settings'],
  mounted() {
    this.appInfo = this.$store.getters.getAppInfo;
    if (this.settings) {
      let settings = _.cloneDeep(this.settings);
      this.form = settings.connectionMethod.connectionMethodData;
      let connectionMethodData = settings.connectionMethod.connectionMethodData;
      if (
        connectionMethodData &&
        connectionMethodData.connectionMethod === 'manual'
      ) {
        this.connectionMode = connectionMethodData.connectionMode;
        this.connectionRunner = connectionMethodData.connectionRunner;
      }
      this.connectionMethodCompatiblity =
        // {
        //   exec: false,
        //   fsock: true,
        //   passthru: true,
        //   shellexec: false,
        //   socketconnect: false,
        //   stream: false,
        //   systemexec: false
        // };
        settings.connectionMethod.connectionMethodCompatibility;
    }
  },
  data() {
    return {
      appInfo: {},
      buttonLoaders: {
        saveChanges: false
      },
      form: {},
      connectionMethodCompatiblity: {},
      connectionMode: null,
      connectionRunner: null,
      selected: 'auto',
      runnerMap: {
        cmdRunnerExec: 'exec',
        cmdRunnerSystem: 'systemexec',
        cmdRunnerPassthru: 'passthru',
        cmdRunnerShellexec: 'shellexec',
        sockRunnerStream: 'stream',
        sockRunnerFsock: 'fsock',
        sockRunnerSocket: 'socketconnect'
      },
      options: [
        {
          text: 'Auto',
          value: 'auto'
        },
        {
          text: 'Manual',
          value: 'manual'
        }
      ],
      modeOptions: [
        {
          text: 'Command mode',
          value: 'commandMode'
        },
        {
          text: 'Socket mode',
          value: 'socketMode'
        },
        {
          text: 'Curl mode',
          value: 'curlMode'
        }
      ],
      runnerOptions: {
        commandMode: [
          {
            text: 'auto',
            value: 'cmdRunnerAuto'
          },
          {
            text: 'Exec',
            value: 'cmdRunnerExec'
          },
          {
            text: 'Passthru',
            value: 'cmdRunnerPassthru'
          },
          {
            text: 'ShellExec',
            value: 'cmdRunnerShellexec'
          },
          {
            text: 'System',
            value: 'cmdRunnerSystem'
          }
        ],
        socketMode: [
          {
            text: 'auto',
            value: 'sockRunnerAuto'
          },

          {
            text: 'stream',
            value: 'sockRunnerStream'
          },
          {
            text: 'fsock',
            value: 'sockRunnerFsock'
          },
          {
            text: 'Socket connect',
            value: 'sockRunnerSocket'
          }
        ],
        curlMode: []
      }
    };
  },
  methods: {
    checkRunnerDisabled(runner) {
      if (runner == 'cmdRunnerAuto' || runner == 'sockRunnerAuto') {
        return false;
      }
      let compatibleRunner = this.runnerMap[runner];
      if (compatibleRunner) {
        return this.connectionMethodCompatiblity[compatibleRunner] === true
          ? false
          : true;
      }
      return true;
    },
    checkModeDisabled(mode) {
      if (mode == 'curlMode') {
        return false;
      }
      let result = true;
      if (mode === 'commandMode') {
        _.each(this.runnerMap, (value, runner) => {
          if (runner.startsWith('cmd')) {
            let tempResult = this.checkRunnerDisabled(runner);
            if (tempResult === false) {
              result = false;
            }
          }
        });
      }
      if (mode === 'socketMode') {
        _.each(this.runnerMap, (value, runner) => {
          if (runner.startsWith('sock')) {
            let tempResult = this.checkRunnerDisabled(runner);
            if (tempResult === false) {
              result = false;
            }
          }
        });
      }
      return result;
    },
    save() {
      this.buttonLoaders.saveChanges = true;
      let payload = {};
      this.form.connectionMode = this.connectionMode;
      this.form.connectionRunner = this.connectionRunner;
      payload.requiredData = {
        updateSettingsAllV3: {
          connectionMethod: { connectionMethodData: this.form }
        },
        getSettingsAllV3: 1
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.buttonLoaders.saveChanges = false;
        this.$store.commit('SET_SETTINGS', response.data.getSettingsAllV3);
      });
    },
    isEveryModesDisabled() {
      let result = false;
      _.each(this.connectionMethodCompatiblity, (value, key) => {
        if (value === false) {
          result = true;
        }
      });
      return result;
    },
    setDefaults() {
      if (this.form.connectionMethod !== 'auto') {
        if (this.connectionMethod == null) {
          let isCommandModeDisabled = this.checkModeDisabled('commandMode');
          if (isCommandModeDisabled === false) {
            this.connectionMode = 'commandMode';
            this.connectionRunner = 'cmdRunnerAuto';
            return;
          }
          let isSocketModeDisabled = this.checkModeDisabled('socketMode');
          if (isSocketModeDisabled === false) {
            this.connectionMode = 'socketMode';
            this.connectionRunner = 'sockRunnerAuto';
            return;
          }
          this.connectionMode = 'curlMode';
        }
      }
    },
    setRunnerDefaults() {
      if (this.connectionMode === 'commandMode') {
        this.connectionRunner = 'cmdRunnerAuto';
        return;
      }
      if (this.connectionMode === 'socketMode') {
        this.connectionRunner = 'sockRunnerAuto';
        return;
      }
    }
  }
};
</script>

<style scoped>
.connectionmethod .custom-control {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/ConnectionMethodSettings.vue